import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {environment} from '../../environments/environment'
import { Transaction } from '../shared/models/transactions/transaction';
import { TransactionDataBundle } from '../shared/models/transactions/transaction-data-bundle';
import { SearchRequest } from '../shared/models/general/search-request';
import { TransactionSearchRequest } from '../shared/models/transactions/transaction-search-request';

@Injectable({
  providedIn: 'root'
})
export class TransactionService {

  env = environment;
  apiUrl = this.env.apiurl + 'platform/transactions/';

  constructor(private http: HttpClient, public router: Router) { }

  public SearchTransactions(model: TransactionSearchRequest): Observable<any> {
    return this.http.post<Transaction[]>(this.apiUrl + 'search', model, {observe: 'response'})
    .pipe(
      map(res => {
        if (res) {
          if (res.status == 200) {
            return res.body.map((data: any) => new Transaction().deserialize(data)); 
          }
        }
      })
    );
  }

  public GetTransactionDataBundleForEntity(SearchRequest: SearchRequest): Observable<TransactionDataBundle[]> {
    return this.http.post<TransactionDataBundle[]>(this.apiUrl + 'databundle' , SearchRequest)
    .pipe(
      map(res => res.map(res => new TransactionDataBundle().deserialize(res)))
    );
  }
}
